import { render } from "./report_card_component.vue?vue&type=template&id=72df8b9a"
import script from "./report_card_component.vue?vue&type=script&lang=js"
export * from "./report_card_component.vue?vue&type=script&lang=js"

import "./report_card_component.vue?vue&type=style&index=0&id=72df8b9a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__